import { NextSeo } from 'next-seo'
import AnalyticsTrigger from '../components/atoms/AnalyticsTrigger'
import Layout from '../components/templates/Layout'

const Faq = () => {
  return (
    <Layout>
      <AnalyticsTrigger title={"よくある質問ページ"} />
      <NextSeo
      title="よくある質問 - デビクレ"
      description="デビクレについてのよくある質問です。" />
      <div className="card">
      <h1>よくある質問</h1>
      <div>
        <div>
          <p>Q. コンテストはいつ開催されますか？</p>
        </div>
        <div>
          <p>A. コンテストの開催情報は当サイトの他、<a href="https://twitter.com/Debicre_boki">Twitter</a>でも告知しておりますので、そちらをご確認ください。</p>
        </div>
      </div>
      </div>
    </Layout>
  )
}

export default Faq
